import { patchRequest, postRequest, getRequest } from "./requests";
import { endpoints } from "./urls";

const runLogin = (reqData) => {
	return postRequest(endpoints.auth.login, reqData);
};
export { runLogin };

const runGetMe = (reqData) => {
	return getRequest(endpoints.auth.me);
};
export { runGetMe };

const runGenerateLicence = (reqData) => {
	return postRequest(endpoints.license.generate, reqData);
};
export { runGenerateLicence };

const runLogout = (reqData) => {
	return postRequest(endpoints.auth.logout, reqData);
};
export { runLogout };

const runChangePassword = (reqData) => {
	return patchRequest(endpoints.auth.password, reqData);
};
export { runChangePassword };

let catalogsCache = null;
let catalogsRequest = null;

const runGetCatalogs = (reqData) => {
	if (catalogsCache) {
		return Promise.resolve(catalogsCache);
	}

	if (catalogsRequest) {
		return catalogsRequest;
	}

	catalogsRequest = getRequest(endpoints.license.catalogs, reqData)
		.then((response) => {
			catalogsCache = response;
			return response;
		})
		.catch((error) => {
			catalogsRequest = null;
			throw error;
		});

	return catalogsRequest;
};
export { runGetCatalogs };

const runGetLicense = (reqData) => {
	return getRequest(endpoints.license.list, reqData);
};
export { runGetLicense };

const runGetPublicLicense = (reqData) => {
	return getRequest(endpoints.license.publicBySerial(reqData.serial));
};
export { runGetPublicLicense };

const runGetTemplate = () => {
	return getRequest(endpoints.license.getTemplate);
};
export { runGetTemplate };

const runUpdateLicense = (id, reqData) => {
	return patchRequest(endpoints.license.updateLicence(id), reqData);
};
export { runUpdateLicense };

const runExportLicensesCsv = () => {
	return getRequest(endpoints.license.exportCsv, undefined, {
		Accept: "text/csv, application/json, */*",
	});
};
export { runExportLicensesCsv };

const runUpdateBulkLicenses = (payload) => {
	return postRequest(endpoints.license.updateBulk, payload);
};
export { runUpdateBulkLicenses };
